"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var properties = {};
var actions = {
  show: 'show',
  hide: 'hide'
};
actions.all = Object.keys(actions);
properties.actions = actions;
var evals = {
  and: 'and',
  or: 'or'
};
evals.all = Object.keys(evals);
properties.evals = evals;
var conditions = {
  filled: '*=',
  empty: 'null=',
  equal: '=',
  notEqual: '!=',
  contain: '?=',
  greaterThan: '>',
  lessThan: '<'
};
conditions.all = Object.keys(conditions).map(function (key) {
  return conditions[key];
});
properties.conditions = conditions;
var _default = exports["default"] = properties;